var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.item.style),attrs:{"src":_vm.getProps(_vm.row, _vm.item.prop)}})}
var staticRenderFns = []

export { render, staticRenderFns }